import { apiClient } from "../index";

const COMPANY_USERS_PATH = "/api/v1/auth/company-users";
const TEAMS_PATH = "/api/v1/teams/";
const ME = "/api/v1/auth/me";
const ORGANIZATION_MEMBERS_PATH = "/api/v1/organizations/";
const PERMISSIONS_PATH = "/api/v1/permissions/user";
const PENDING_APPROVALS_PATH = "/api/v1/catalog/scenarios/pending-approval";
const APPROVE_SCENARIO_PATH = "/api/v1/catalog/scenarios";

export async function createCompanyUser(userData) {
  const payload = {
    first_name: userData.first_name,
    last_name: userData.last_name,
    username: userData.username,
    email: userData.email,
    designation: userData.designation,
    allow_scenario_creation: userData.allow_scenario_creation,
    allow_topology_access: userData.allow_topology_access,
  };

  if (userData.team_id) {
    payload.team_id = userData.team_id;
  }

  return apiClient.post(COMPANY_USERS_PATH, payload);
}

export async function createTeam({ name }) {
  const payload = {
    name,
  };

  return apiClient.post(TEAMS_PATH, payload);
}

export async function getTeams({ page = 1, pageSize = 100 } = {}) {
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });

  return apiClient.get(`${TEAMS_PATH}?${query.toString()}`);
}

export async function getTeamById(teamId) {
  return apiClient.get(`${TEAMS_PATH}${teamId}`);
}

export async function getCurrentUser() {
  return apiClient.get(ME);
}

export async function getOrganizationMembers(
  organizationId,
  { page = 1, pageSize = 100 } = {},
) {
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  return apiClient.get(
    `${ORGANIZATION_MEMBERS_PATH}${organizationId}/members?${query.toString()}`,
  );
}

export async function getTeamMembers(
  teamId,
  { page = 1, pageSize = 100 } = {},
) {
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });

  return apiClient.get(`${TEAMS_PATH}${teamId}/members?${query.toString()}`);
}

export async function addTeamMembers(teamId, userIds) {
  return apiClient.post(`${TEAMS_PATH}${teamId}/members`, {
    user_ids: userIds,
  });
}

export async function removeTeamMember(teamId, userId) {
  return apiClient.del(`${TEAMS_PATH}${teamId}/members/${userId}`);
}

export async function updateUserPermissions(userId, overrides) {
  return apiClient.put(`${PERMISSIONS_PATH}/${userId}/overrides`, {
    overrides,
  });
}

export async function getPendingApprovals() {
  return apiClient.get(PENDING_APPROVALS_PATH);
}

export async function approveScenario(scenarioId) {
  return apiClient.post(`${APPROVE_SCENARIO_PATH}/${scenarioId}/approve`);
}

export async function rejectScenario(scenarioId) {
  return apiClient.post(`${APPROVE_SCENARIO_PATH}/${scenarioId}/reject`);
}
